var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../valueObjects/guid"], function (require, exports, guid_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ToastNotification = void 0;
    guid_1 = __importDefault(guid_1);
    var ToastClassConfig = (function () {
        function ToastClassConfig() {
            this.Alert = 'bg-orange-500';
            this.Error = 'bg-red-500';
            this.Success = 'bg-green-500';
        }
        return ToastClassConfig;
    }());
    var ToastNotification = (function () {
        function ToastNotification() {
        }
        ToastNotification.CreateLabel = function (timeoutMs, onClose) {
            var _this = this;
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            if (onClose === void 0) { onClose = null; }
            var guid = new guid_1.default();
            var div = document.createElement('div');
            div.id = guid.toString();
            div.classList.add('hidden', 'alert-toast', 'flex', 'flex-col', 'float-right', 'm-8', 'pointer-events-auto', 'bg-red-500', 'shadow-lg', 'rounded');
            div.style.zIndex = '9999';
            var btnClose = document.createElement('button');
            btnClose.innerHTML = "\n          <svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"15\" height=\"15\" viewBox=\"0,0,256,256\">\n            <g fill=\"#ffffff\" fill-rule=\"nonzero\" stroke=\"none\" stroke-width=\"1\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" stroke-miterlimit=\"10\" stroke-dasharray=\"\" stroke-dashoffset=\"0\" font-family=\"none\" font-weight=\"none\" font-size=\"none\" text-anchor=\"none\" style=\"mix-blend-mode: normal\"><g transform=\"scale(10.66667,10.66667)\"><path d=\"M19.61914,2.58203l-0.88086,0.88477l-6.74219,6.76367l-6.72461,-6.72461l-0.88281,-0.88477l-1.76758,1.76758l0.88281,0.88477l6.72852,6.72852l-6.73047,6.75195l-0.88086,0.88672l1.76953,1.76367l0.88281,-0.88477l6.72656,-6.75l6.72656,6.72461l0.88281,0.88477l1.76758,-1.76758l-0.88281,-0.88477l-6.72852,-6.72852l6.74219,-6.76563l0.88281,-0.88477z\"></path></g></g>\n          </svg>";
            btnClose.classList.add('self-end', 'mt-2', 'mr-2', 'border-none');
            btnClose.title = 'Fechar';
            btnClose.addEventListener('click', function (e) {
                _this.DestroyToast(e, div);
                if (onClose) {
                    onClose();
                }
            });
            div.appendChild(btnClose);
            var lbl = document.createElement('label');
            lbl.classList.add('cursor-pointer', 'items-start', 'justify-between', 'w-full', 'py-3', 'px-2', 'text-white', 'text-sm');
            lbl.setAttribute('for', 'footertoast');
            div.appendChild(lbl);
            if (timeoutMs) {
                var progressBar = document.createElement('div');
                progressBar.classList.add('toast-progress');
                progressBar.style.height = '4px';
                progressBar.style.backgroundColor = 'white';
                progressBar.style.width = '100%';
                progressBar.style.transition = 'width linear';
                progressBar.style.borderBottomLeftRadius = '4px';
                progressBar.style.borderBottomRightRadius = '4px';
                div.appendChild(progressBar);
            }
            return lbl;
        };
        ToastNotification.GetLabel = function (timeoutMs, onClose) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            if (onClose === void 0) { onClose = null; }
            return this.CreateLabel(timeoutMs, onClose);
        };
        ToastNotification.GetDivToasts = function () {
            return document.getElementById(this._divToasts);
        };
        ToastNotification.Alert = function (text, timeoutMs) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            var lbl = this.GetLabel(timeoutMs);
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.parentElement.classList.remove(config.Error);
            lbl.parentElement.classList.remove(config.Success);
            lbl.parentElement.classList.add(config.Alert);
            console.warn(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.alert);
        };
        ToastNotification.Error = function (text, timeoutMs, hideOthers) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            if (hideOthers === void 0) { hideOthers = false; }
            var lbl = this.GetLabel(timeoutMs);
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.parentElement.classList.remove(config.Alert);
            lbl.parentElement.classList.remove(config.Success);
            lbl.parentElement.classList.add(config.Error);
            console.error(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.error, hideOthers);
        };
        ToastNotification.Success = function (text, timeoutMs, onClose) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            if (onClose === void 0) { onClose = null; }
            var lbl = this.GetLabel(timeoutMs, onClose);
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.parentElement.classList.remove(config.Alert);
            lbl.parentElement.classList.remove(config.Error);
            lbl.parentElement.classList.add(config.Success);
            console.info(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.success);
        };
        ToastNotification.SetLabel = function (lbl, text, timeoutMs, type, hideOthers) {
            if (hideOthers === void 0) { hideOthers = false; }
            var parent = lbl === null || lbl === void 0 ? void 0 : lbl.parentElement;
            var divToasts = this.GetDivToasts();
            if (!lbl || !parent || !divToasts)
                return;
            var sameToast = this.GetToastSameText(text, type);
            if (!sameToast || hideOthers) {
                if (hideOthers)
                    Array.from(divToasts.children).forEach(function (elem) {
                        elem.remove();
                    });
                lbl.innerText = text;
                divToasts.appendChild(parent);
                parent.classList.remove('hidden');
                parent.setAttribute(this._refreshAttr, "false");
                this.SetToastType(parent, type);
                if (timeoutMs) {
                    this.HideAfter(lbl, timeoutMs);
                }
            }
            else {
                parent.remove();
                var oldParent = sameToast.parentElement;
                oldParent.setAttribute(this._refreshAttr, "true");
                oldParent.classList.remove('hidden');
            }
        };
        ToastNotification.SetToastType = function (div, type) {
            div.setAttribute(this._typeAttr, "" + type);
        };
        ToastNotification.GetToastType = function (div) {
            return Number(div.getAttribute(this._typeAttr));
        };
        ToastNotification.GetToastSameText = function (text, msgType) {
            var toasts = this.GetDivToasts();
            if (!toasts)
                return null;
            var list = Array.from(toasts.children);
            for (var c = 0; c < list.length; c++) {
                var div = list[c];
                if (!div)
                    continue;
                var type = this.GetToastType(div);
                if (msgType != type)
                    continue;
                var lbl = Array.from(div.getElementsByTagName('label'));
                if (!lbl)
                    continue;
                var res = lbl.filter(function (x) {
                    return x.innerText == text;
                });
                if (!res || res.length === 0)
                    continue;
                return res[0];
            }
            return null;
        };
        ToastNotification.HideAfter = function (lbl, timeoutMs) {
            var _this = this;
            if (!lbl)
                return;
            var parent = lbl.parentElement;
            var progressBar = Array.from(parent.children).find(function (child) { return child.classList.contains('toast-progress'); });
            if (progressBar) {
                progressBar.style.transitionDuration = timeoutMs + "ms";
                progressBar.style.width = '100%';
                void progressBar.offsetWidth;
                setTimeout(function () {
                    progressBar.style.width = '0%';
                }, 50);
            }
            setTimeout(function () {
                var currentParent = lbl.parentElement;
                if (!currentParent) {
                    lbl.remove();
                    return;
                }
                var refreshed = currentParent.getAttribute(_this._refreshAttr);
                if (refreshed === 'true') {
                    currentParent.setAttribute(_this._refreshAttr, 'false');
                    _this.HideAfter(lbl, timeoutMs);
                }
                else {
                    _this.Hide(lbl);
                }
            }, timeoutMs);
        };
        ToastNotification.Hide = function (lbl) {
            if (!lbl)
                return;
            var parent = lbl.parentElement;
            if (!parent)
                return;
            var btnClose = parent.querySelector('button');
            if (btnClose) {
                btnClose.dispatchEvent(new MouseEvent('click'));
            }
            else {
                this.DestroyToast(new MouseEvent('click'), parent);
            }
        };
        ToastNotification.DestroyToast = function (e, lblParent) {
            var _this = this;
            if (!lblParent)
                return;
            lblParent.classList.add('hidden');
            setTimeout(function () {
                if (lblParent.classList.contains('hidden'))
                    lblParent.remove();
                else
                    _this.DestroyToast(e, lblParent);
            }, 1000);
        };
        ToastNotification._divToasts = 'div-toasts';
        ToastNotification._typeAttr = 'data-toast-type';
        ToastNotification._refreshAttr = 'data-toast-refreshed';
        ToastNotification._type = {
            success: 1,
            alert: 2,
            error: 3
        };
        ToastNotification.GetConfig = function () {
            return new ToastClassConfig();
        };
        return ToastNotification;
    }());
    exports.ToastNotification = ToastNotification;
});
